<!-- Technikerinfos / Zugang (from BMD Kopftext import + legacy zutritt remark) -->
<div *ngIf="hasTechnikerInfos() || canEdit" class="mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">

  <div class="flex items-center justify-between gap-2 mb-3">
    <p class="text-sm font-semibold text-amber-800 flex items-center gap-1">
      <mat-icon class="w-4 h-4 text-base leading-none">vpn_key</mat-icon>
      {{ 'APPOINTMENT_EDIT.SECTION_TECHNIKERINFOS' | translate }}
    </p>

    <div class="flex items-center gap-1" *ngIf="canEdit">
      <button *ngIf="!editMode" type="button"
              class="w-7 h-7 rounded-full flex items-center justify-center text-amber-800 hover:bg-amber-100"
              [matTooltip]="'APPOINTMENT_EDIT.TECHNIKERINFOS_EDIT' | translate"
              (click)="startEdit()">
        <mat-icon class="w-4 h-4 text-base leading-none">edit</mat-icon>
      </button>
      <button *ngIf="!editMode" type="button"
              class="w-7 h-7 rounded-full flex items-center justify-center hover:bg-amber-100"
              [class.text-amber-800]="!historyOpen" [class.text-blue-700]="historyOpen"
              [matTooltip]="'APPOINTMENT_EDIT.TECHNIKERINFOS_HISTORY' | translate"
              (click)="toggleHistory()">
        <mat-icon class="w-4 h-4 text-base leading-none">history</mat-icon>
      </button>
    </div>
  </div>

  <!-- READ MODE -->
  <div *ngIf="!editMode" class="space-y-3">
    <div *ngFor="let f of fields">
      <ng-container *ngIf="displayValue(f.key).trim()">
        <p class="text-xs font-semibold text-amber-800 uppercase tracking-wide mb-0.5">{{ f.label | translate }}</p>
        <p class="text-sm text-gray-800 whitespace-pre-line break-words">{{ displayValue(f.key) }}</p>
      </ng-container>
    </div>

    <p *ngIf="!hasTechnikerInfos()" class="text-sm text-gray-500 italic">
      {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_EMPTY' | translate }}
    </p>
  </div>

  <!-- EDIT MODE -->
  <div *ngIf="editMode" class="space-y-3">
    <div *ngFor="let f of fields">
      <p class="text-xs font-semibold text-amber-800 uppercase tracking-wide mb-0.5">{{ f.label | translate }}</p>
      <textarea [(ngModel)]="draft[f.key]" [name]="f.key" rows="2"
                class="w-full text-sm text-gray-800 bg-white border border-amber-200 rounded px-2 py-1 focus:outline-none focus:border-amber-400"></textarea>
    </div>

    <p *ngIf="saveError" class="text-sm text-red-700">{{ saveError }}</p>

    <div class="flex items-center gap-2 pt-1">
      <button type="button" mat-flat-button color="primary" class="text-xs" [disabled]="saving" (click)="save()">
        {{ (saving ? 'APPOINTMENT_EDIT.TECHNIKERINFOS_SAVING' : 'APPOINTMENT_EDIT.TECHNIKERINFOS_SAVE') | translate }}
      </button>
      <button type="button" mat-stroked-button class="text-xs" [disabled]="saving" (click)="cancelEdit()">
        {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_CANCEL' | translate }}
      </button>
    </div>
  </div>

  <!-- LAST CHANGED -->
  <p *ngIf="lastRevision && !editMode" class="text-xs text-amber-700 mt-3">
    {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_LAST_CHANGED' | translate }}
    {{ lastRevision.changed_by_name || '–' }},
    {{ lastRevision.created_at | date: 'dd.MM.yyyy HH:mm' }}
  </p>

  <!-- HISTORY (step back through versions, restore without destroying anything) -->
  <div *ngIf="historyOpen && !editMode" class="mt-3 pt-3 border-t border-amber-200">
    <div *ngIf="historyLoading" class="text-xs text-gray-500">
      {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_HISTORY_LOADING' | translate }}
    </div>
    <p *ngIf="historyError" class="text-xs text-red-700">{{ historyError }}</p>

    <p *ngIf="!historyLoading && !historyError && revisions.length === 0" class="text-xs text-gray-500">
      {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_NO_HISTORY' | translate }}
    </p>

    <div *ngIf="!historyLoading && revisions.length > 0">
      <input type="range" class="w-full accent-amber-600"
             min="0" [max]="revisions.length - 1" step="1"
             [value]="selectedIndex" (input)="onVersionChange($any($event.target).value)" />

      <div class="flex items-center justify-between gap-2 flex-wrap text-xs text-amber-800 mt-1">
        <span>
          {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_VERSION' | translate }} {{ selectedIndex + 1 }}/{{ revisions.length }}
          &middot; {{ selectedRevision?.created_at | date: 'dd.MM.yyyy HH:mm' }}
          &middot; {{ selectedRevision?.changed_by_name || ('APPOINTMENT_EDIT.TECHNIKERINFOS_IMPORTED' | translate) }}
          <span *ngIf="!isPreviewingOldVersion" class="text-green-700">({{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_CURRENT' | translate }})</span>
        </span>

        <button *ngIf="isPreviewingOldVersion" type="button" mat-stroked-button class="text-xs"
                [disabled]="saving" (click)="restoreSelected()">
          {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_RESTORE' | translate }}
        </button>
      </div>

      <p *ngIf="isPreviewingOldVersion" class="text-xs text-blue-700 mt-1">
        {{ 'APPOINTMENT_EDIT.TECHNIKERINFOS_PREVIEW_HINT' | translate }}
      </p>
    </div>
  </div>
</div>
